import { __assign, __extends, __rest } from "tslib";
import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

var Image =
/** @class */
function (_super) {
  __extends(Image, _super);

  function Image(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.IMAGE,
      style: __assign({
        img: '',
        width: 'auto',
        height: 'auto',
        lineWidth: 0
      }, style)
    }, rest)) || this;
  }

  return Image;
}(DisplayObject);

export { Image };